module.exports = __webpack_public_path__ + "static/media/arrow-right-gray.323f33c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-right-gray.svg
// module id = 1450
// module chunks = 0